import { type TeamStatus } from '@/model/firestore/schema/TeamStatusZod'

export const teamStatus = (status: TeamStatus): 'available' | 'paused' | 'returning' | undefined => {
  switch (status) {
    case 'AVAILABLE_IN_LOCATION':
    case 'AVAILABLE_IN_INSTITUTION':
    case 'AVAILABLE_IN_REGION':
    case 'AVAILABLE_AT_COORDINATES':
      return 'available'
    case 'ON_BREAK':
      return 'paused'
    case 'IN_RETURN':
      return 'returning'
    default:
      return undefined
  }
}
